import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "store";
import { useWindowDimensions } from "resources/BrowserManager";
import { debounce } from "lodash";

import {
  ArrowUpOutlined,
  UnorderedListOutlined,
  ExclamationCircleFilled,
  CloseCircleFilled,
  CheckCircleFilled,
  MinusCircleFilled,
  InfoCircleOutlined,
} from "@ant-design/icons";

import {
  Button,
  Table,
  Tag,
  Tooltip,
  Space,
  Typography,
  Flex,
  Alert,
  theme,
} from "antd";
const { Text } = Typography;

export default function TableEFOS({
  efosLinksFirstPage,
  efosLinksPaginationToken,
}) {
  const { token: theme_token } = theme.useToken();

  const { isSmallView, isMediumView } = useWindowDimensions();
  const navigate = useNavigate();

  const user = useStore((state) => state.user);
  const activeRfc = useStore((state) => state.activeRfc);

  const [tableData, setTableData] = useState(efosLinksFirstPage);
  const [paginationToken, setPaginationToken] = useState(
    efosLinksPaginationToken
  );

  const [isLoadingCfdis, setLoadingCfdis] = useState(true);
  const [isLazyLoading, setIsLazyLoading] = useState(false);
  const [canScrollToTop, setCanScrollToTop] = useState(null);

  /*
  const getUserCfdis = async (isManualRefresh) => {
    setLoadingCfdis(true);

    let isFirstPage = true;
    const path = "/user/cfdis";
    const headers = { token: token };
    let payload = {};

    if (!!cfdiSearchFilters) {
      payload.search_filters = {};

      if (cfdiSearchFilters.hasOwnProperty("uuid")) {
        payload.id_cfdi = cfdiSearchFilters.uuid;
        payload.search_filters.uuid = cfdiSearchFilters.uuid;
      }

      if (
        cfdiSearchFilters.hasOwnProperty("date_from") &&
        cfdiSearchFilters.date_from &&
        cfdiSearchFilters.hasOwnProperty("date_to") &&
        cfdiSearchFilters.date_to
      ) {
        payload.search_filters.date_from = cfdiSearchFilters.date_from;
        payload.search_filters.date_to = cfdiSearchFilters.date_to;
      }

      if (cfdiSearchFilters.hasOwnProperty("name") && cfdiSearchFilters.name) {
        payload.search_filters.name = cfdiSearchFilters.name;
      }

      if (cfdiSearchFilters.hasOwnProperty("rfc") && cfdiSearchFilters.rfc) {
        payload.search_filters.rfc = cfdiSearchFilters.rfc;
      }

      if (
        cfdiSearchFilters.hasOwnProperty("amount_min") &&
        cfdiSearchFilters.amount_min
      ) {
        payload.search_filters.amount_min = cfdiSearchFilters.amount_min;
      }

      if (
        cfdiSearchFilters.hasOwnProperty("amount_max") &&
        cfdiSearchFilters.amount_max
      ) {
        payload.search_filters.amount_max = cfdiSearchFilters.amount_max;
      }

      if (cfdiSearchFilters.hasOwnProperty("tags") && cfdiSearchFilters.tags) {
        payload.search_filters.tags = cfdiSearchFilters.tags;
      }

      payload.search_filters = JSON.stringify(payload.search_filters);
    }

    if (!isManualRefresh && paginationToken) {
      payload.pagination_token = paginationToken;
      isFirstPage = false;
    }

    const response = await axios
      .get(path, { headers, params: payload })
      .catch((error) => {
        message.error(strings.alertUnexpectedError);
        setLoadingCfdis(false);
      });

    const responseCode = response.data.response.code;
    let data = response.data.data;

    if (responseCode === 2000) {
      const { cfdis, pagination_token } = data;

      setTableData((prev) => {
        return !isManualRefresh && prev ? prev.concat(cfdis) : cfdis;
      });

      setIsLazyLoading(false);

      if (!!!cfdiSearchFilters && isFirstPage) {
        // setRfcRecentCfdis(activeRfc, cfdiType, cfdis);
      }

      if (pagination_token) {
        setPaginationToken(pagination_token);
      } else {
        setPaginationToken(null);
      }
    } else if (responseCode === 1003) {
      setTableData([]);
      setIsLazyLoading(false);
      setPaginationToken(null);
    } else {
      message.error(strings.alertUnexpectedError);
    }

    setLoadingCfdis(false);
  };

  useEffect(() => {
    const onScroll = debounce(() => {
      const percentScrolled =
        (document.scrollingElement.scrollTop /
          (document.scrollingElement.scrollHeight -
            document.scrollingElement.clientHeight)) *
        100;

      if (percentScrolled > 0) {
        setCanScrollToTop(true);
      } else {
        setCanScrollToTop(false);
      }

      if (
        !isLazyLoading &&
        paginationToken &&
        tableData &&
        !!tableData?.length &&
        percentScrolled >= 80
      ) {
        setIsLazyLoading(true);
        getUserCfdis(false);
      }
    }, 500);

    document.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [isLazyLoading, paginationToken, tableData]);
  */

  const EFOS_INFO = {
    PRESUNTO: {
      label: "Presunto",
      color: "orange", //"#B36A00", // Muted amber, warmer and calmer than the original
      icon: <ExclamationCircleFilled />,
      tooltip: (
        <div>
          <strong>Presunto</strong>
          <br />
          El contribuyente se encuentra listado como presunto EFOS por el SAT.
          <br />
          La situación aún puede ser aclarada.
        </div>
      ),
    },

    DEFINITIVO: {
      label: "Definitivo",
      color: "red", //"#DA2626", // Matches theme colorError
      icon: <CloseCircleFilled />,
      tooltip: (
        <div>
          <strong>Definitivo</strong>
          <br />
          El SAT ha confirmado de forma definitiva al contribuyente como EFOS.
        </div>
      ),
    },

    DESVIRTUADO: {
      label: "Desvirtuado",
      color: "green", //"#00750A", // Matches theme colorSucess
      icon: <CheckCircleFilled />,
      tooltip: (
        <div>
          <strong>Desvirtuado</strong>
          <br />
          El contribuyente logró aclarar su situación ante el SAT.
        </div>
      ),
    },

    SENTENCIA_FAVORABLE: {
      label: "Sentencia favorable",
      color: "geekblue", //"#1C5676", // Primary navy blue
      icon: <CheckCircleFilled />,
      tooltip: (
        <div>
          <strong>Sentencia favorable</strong>
          <br />
          Existe una resolución judicial favorable para el contribuyente.
        </div>
      ),
    },

    _REMOVED: {
      label: "Removido",
      color: "", //"#6B7280", // Neutral cool gray with better harmony
      icon: <MinusCircleFilled />,
      tooltip: (
        <div>
          <strong>Removido</strong>
          <br />
          El contribuyente ha sido removido de la lista de EFOS del SAT.
        </div>
      ),
    },
  };

  const renderTags = (item) => {
    const tags = { efos_status: item.efos.efos_status };

    const items = [];
    Object.entries(tags).forEach(([type, val]) => {
      let label = val;
      let color = "gray";
      let icon = null;
      let tooltip = null;

      if (type === "efos_status") {
        label = EFOS_INFO[val]["label"];
        color = EFOS_INFO[val]["color"];
        icon = EFOS_INFO[val]["icon"];
        tooltip = EFOS_INFO[val]["tooltip"];
      }

      items.push(
        <span key={item.efos.rfc}>
          <Tooltip title={tooltip} overlayStyle={{ maxWidth: 300 }}>
            <Tag
              icon={icon}
              color={color}
              // style={{ color: "#fff", fontWeight: 500, cursor: "help" }}
              style={{ cursor: "help" }}
              key={label}
            >
              {label}
            </Tag>
          </Tooltip>
        </span>
      );
    });

    return <Flex>{items}</Flex>;
  };

  const renderButtons = (item) => {
    return (
      <Flex justify="flex-end" gap={5}>
        <Button
          type="primary"
          icon={<UnorderedListOutlined />}
          size="small"
          onClick={() => handleListCfdisButton(item.efos_link, item.efos.rfc)}
        >
          Ver CFDIs
        </Button>
      </Flex>
    );
  };

  const renderInfo = (item) => (
    <Space direction="vertical" size={0}>
      <Text strong>
        {item.efos.sat_fiscal_name}
        &nbsp;&nbsp;
        <Tag
          color={item.efos_link === "emitter" ? "blue" : "green"}
          style={{ fontWeight: "normal" }}
        >
          {item.efos_link === "emitter" ? "Emisor" : "Receptor"}
        </Tag>
      </Text>

      <Text strong style={{ color: "#801794" }}>
        {item.efos.rfc}
      </Text>
      {/* <Text>{getFormattedUnixDate(item.efos.created_at)}</Text> */}
    </Space>
  );

  const handleListCfdisButton = (efos_link, efos_rfc) => {
    navigate("/cfdis?efos_link=" + efos_link + "&efos_rfc=" + efos_rfc);
  };

  const handleScrollToTop = () => {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  };

  const columns = isSmallView
    ? [
        {
          title: "Info",
          dataIndex: "info",
          key: "info",
          align: "left",
          render: (_, { item }) => {
            return (
              <Space direction="vertical" size={10}>
                <Space direction="vertical" size={3}>
                  {renderInfo(item)}
                  {renderTags(item)}
                </Space>
                <Space direction="vertical">{renderButtons(item)}</Space>
              </Space>
            );
          },
        },
      ]
    : isMediumView
    ? [
        {
          title: "Info",
          dataIndex: "info",
          key: "info",
          align: "left",
          render: (_, { item }) => {
            return (
              <Space direction="vertical" size={3}>
                {renderInfo(item)}
                {renderTags(item)}
              </Space>
            );
          },
        },
        {
          title: "Info",
          dataIndex: "info",
          key: "info",
          align: "right",
          render: (_, { item }) => {
            return (
              <Space direction="vertical" size={10}>
                {renderButtons(item)}
              </Space>
            );
          },
        },
      ]
    : [
        {
          dataIndex: "info",
          key: "info",
          align: "left",
          render: (_, { item }) => {
            return (
              <Space direction="vertical" size={3}>
                {renderInfo(item)}
              </Space>
            );
          },
        },
        {
          dataIndex: "tags",
          key: "tags",
          align: "center",
          render: (_, { item }) => {
            return (
              <Space direction="vertical" size={3}>
                {renderTags(item)}
              </Space>
            );
          },
        },
        {
          title: "",
          keys: "buttons",
          align: "right",
          render: (_, { item }) => renderButtons(item),
        },
      ];

  let dataSource = tableData?.map((item, i) => {
    return {
      key: item.efos.rfc + "_" + i,
      item: item,
    };
  });

  return (
    <>
      {/* <Button
        type="primary"
        shape="circle"
        disabled={isLoadingCfdis}
        icon={<RedoOutlined spin={isLoadingCfdis} />}
        onClick={() => getUserCfdis(true)}
        style={{ float: "right", marginTop: isSmallView ? "-55px" : "-65px" }}
        size={isSmallView ? "small" : "middle"}
      />
      */}

      <Button
        type="primary"
        shape="circle"
        icon={<ArrowUpOutlined />}
        onClick={handleScrollToTop}
        style={{
          zIndex: 100,
          backgroundColor: "#801794",
          position: "fixed",
          bottom: 20,
          right: 20,
          opacity: canScrollToTop ? 1 : 0,
          transition: "all .2s",
          visibility: canScrollToTop ? "visible" : "hidden",
        }}
      />

      {!!tableData?.length && (
        <Flex vertical gap={20}>
          <Alert
            message={
              <Text>
                <span style={{ fontWeight: 600 }}>
                  Se detectaron CFDIs relacionados con EFOS:
                </span>
                &nbsp;La lista muestra los RFCs detectados por el SAT como EFOS,
                con su respectivo estatus. Da clic en "Ver CFDIs" para revisar
                los comprobantes relacionados con cada EFOS.
              </Text>
            }
            type="info"
            icon={
              <InfoCircleOutlined style={{ color: theme_token.colorPrimary }} />
            }
            style={{
              backgroundColor: theme_token.colorBgTertiary,
            }}
            showIcon
          />
          <Table
            size="small"
            columns={columns}
            dataSource={dataSource}
            locale={{ emptyText: null }}
            showHeader={false}
            pagination={false}
            isLoadingCfdis={isLoadingCfdis}
          />
        </Flex>
      )}

      {/* {(paginationToken || (isLoadingCfdis && !tableData?.length)) && (
        <Flex justify="center">
          <Loading3QuartersOutlined
            spin
            style={{
              fontSize: "20px",
              color: "#801794",
              margin: "20px 0px",
            }}
          />
        </Flex>
      )}

      {!!!paginationToken && !!!isLoadingCfdis && (
        <Card style={{ marginTop: "30px", marginBottom: "50px" }}>
          <Flex justify="center">
            <Space direction="vertical" style={{ textAlign: "center" }}>
              <Space>
                <ExclamationCircleOutlined
                  style={{
                    fontSize: "20px",
                    color: "#1C5676",
                    marginTop: "4px",
                  }}
                />
                <Text style={{ fontSize: "15px" }}>
                  Se han cargado todos los CFDIs.
                </Text>
              </Space>
            </Space>
          </Flex>
        </Card>
      )} */}
    </>
  );
}
